<script setup>
const props = defineProps({
  class: {
    type: String,
    default: ''
  }
})
</script>
<template>
  <svg 
    :class="props.class"
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.95455 2.5C8.45247 2.5 8.04545 2.85817 8.04545 3.3V9.7C8.04545 10.1418 8.45247 10.5 8.95455 10.5H10.0909C10.593 10.5 11 10.1418 11 9.7V3.3C11 2.85817 10.593 2.5 10.0909 2.5H8.95455ZM10.0909 3.2H8.95455C8.89179 3.2 8.84091 3.24477 8.84091 3.3V9.7C8.84091 9.75523 8.89179 9.8 8.95455 9.8H10.0909C10.1537 9.8 10.2045 9.75523 10.2045 9.7V3.3C10.2045 3.24477 10.1537 3.2 10.0909 3.2Z" 
      fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.31818 4.9C4.8161 4.9 4.40909 5.25817 4.40909 5.7V9.7C4.40909 10.1418 4.8161 10.5 5.31818 10.5H6.45455C6.95662 10.5 7.36364 10.1418 7.36364 9.7V5.7C7.36364 5.25817 6.95662 4.9 6.45455 4.9H5.31818ZM6.45455 5.6H5.31818C5.25542 5.6 5.20455 5.64477 5.20455 5.7V9.7C5.20455 9.75523 5.25542 9.8 5.31818 9.8H6.45455C6.51731 9.8 6.56818 9.75523 6.56818 9.7V5.7C6.56818 5.64477 6.51731 5.6 6.45455 5.6Z" 
      fill="currentColor"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 7.7C1 7.25817 1.40701 6.9 1.90909 6.9H3.04545C3.54753 6.9 3.95455 7.25817 3.95455 7.7V9.7C3.95455 10.1418 3.54753 10.5 3.04545 10.5H1.90909C1.40701 10.5 1 10.1418 1 9.7V7.7ZM1.90909 7.6H3.04545C3.10821 7.6 3.15909 7.64477 3.15909 7.7V9.7C3.15909 9.75523 3.10821 9.8 3.04545 9.8H1.90909C1.84633 9.8 1.79545 9.75523 1.79545 9.7V7.7C1.79545 7.64477 1.84633 7.6 1.90909 7.6Z" 
      fill="currentColor"/>
  </svg>
</template>